import { render, staticRenderFns } from "./ServiceRequestThirtyDays.vue?vue&type=template&id=b4744452&"
import script from "./ServiceRequestThirtyDays.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestThirtyDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports